$(document).on("turbolinks:load", () => {
  $('.datepicker-control').datepicker({
      format: "yyyy-mm-dd",
      todayHighlight: true
  });
});
